export default __webpack_public_path__ + "static/media/button-active.c34a6398.svg";